import { useContext, useState } from "react";

import { useTranslation } from "react-i18next";

import Button, {
    BUTTON_COLORS,
    BUTTON_SIZES,
    BUTTON_VARIANTS
} from "components/DesignComponents/Button";
import ActionToolbarButtonWrapper from "components/DesignComponents/Button/ActionToolbarButtonWrapper";
import AlertContext, { ALERT_STATUS } from "context/alert/alertContext";
import ParamsContext from "context/params/paramsContext";
import TableContext from "context/table/tableContext";
import { useApi } from "shared/hooks/useApi";
import { useMediaQueries } from "shared/hooks/useMediaQueries";
import {
    ENDPOINT_PATH_SEGMENTS,
    ENDPOINTS,
    TABLE_NAMES
} from "shared/types/enums";

import CreateModel from "../dialogs/DeviceModels/CreateModel";
import { DEVICE_MODEL_ACTIONS } from "../types";
import ContentFrame from "./components/ContentFrame";
import { useDialog } from "./hooks";

const DeviceModelsBar = () => {
    const { setAlert } = useContext(AlertContext);
    const { setReloadItems } = useContext(ParamsContext);
    const { isInitialLoading } = useContext(TableContext);

    const { t } = useTranslation();
    const { toSm } = useMediaQueries();
    const { postData, handleResponse } = useApi();
    const { isOpenDialog, openDialog, closeDialog } = useDialog();

    const [isLoading, setIsLoading] = useState(false);

    const synchronizeSubmit = async () => {
        try {
            setIsLoading(true);

            const {
                data: { compatibilities_added }
            } = await postData(
                `${ENDPOINTS.DeviceModelTaskCompatibilities}${ENDPOINT_PATH_SEGMENTS.AddMissingCompatibilities}`
            );

            setReloadItems(TABLE_NAMES.DeviceModelTaskCompatibilities);

            setAlert({
                status: ALERT_STATUS.Success,
                title: t("Flash##compatibilities synchronized"),
                description: t("Flash##compatibilities added", {
                    count: compatibilities_added
                })
            });
        } catch (error) {
            handleResponse(error);
        }

        setIsLoading(false);
    };

    return (
        <>
            <ContentFrame>
                <ActionToolbarButtonWrapper>
                    <Button
                        fullWidth={toSm}
                        hasRectangleLoader={toSm && isInitialLoading}
                        variant={BUTTON_VARIANTS.TextOnly}
                        size={BUTTON_SIZES.Small}
                        color={BUTTON_COLORS.Primary}
                        onClick={() =>
                            openDialog(DEVICE_MODEL_ACTIONS.CreateModel)
                        }
                    >
                        {t("Button##create")}
                    </Button>
                </ActionToolbarButtonWrapper>

                <ActionToolbarButtonWrapper>
                    <Button
                        variant={BUTTON_VARIANTS.TextOnly}
                        size={BUTTON_SIZES.Small}
                        color={BUTTON_COLORS.White}
                        isLoading={isLoading}
                        onClick={synchronizeSubmit}
                    >
                        {t("Button##synchronize")}
                    </Button>
                </ActionToolbarButtonWrapper>
            </ContentFrame>

            <CreateModel
                isOpen={isOpenDialog[DEVICE_MODEL_ACTIONS.CreateModel]}
                close={closeDialog}
            />
        </>
    );
};

export default DeviceModelsBar;
